<template>
<v-container class="mb-0 px-2">
    <h2 class="texts">{{title}} ({{porcent}}%)
      <!-- <v-btn
        v-if="countList > 1"
        color="primary"
        depressed
        x-small
        icon
        class="px-2 ml-2"
        @click="toogleShow"
        >
        <v-icon x-small>{{countList > qtde? 'fa-plus-circle' : 'fa-minus-circle'}}</v-icon>
      </v-btn> -->
    </h2>
    <v-data-table
        :id="tableName"
        v-if="showTable"
        dense
        hide-default-footer
        :headers="dinamicHeader"
        :items="list"
        class="lotesListTable"
        :items-per-page="qtde"
      >
      <template v-slot:item.ident_operadora="{ item }">
          <b v-if="item.ident_operadora == 'Total'">TOTAL</b>
          <span v-else>{{item.ident_operadora}}</span>
        </template>
        <template v-slot:item.valor_informado="{ item }">
          <b>{{ item.valor_informado | formatPrice}}</b>
        </template>
        <!-- <template v-slot:item.valor_informado="{ item }">
          <b style="color:#D0021B"  v-if="item.valor_informado">{{ item.valor_informado | formatPrice }}</b>
        </template> -->
        <template v-slot:item.valor_liberado="{ item }">
          <b style="color:#32B88B">{{ item.valor_liberado | formatPrice }}</b>
        </template>
        <template v-slot:item.valor_glosado="{ item }">
          <span style="color:#D0021B">{{ item.valor_glosado | formatPrice }}</span>
        </template>
        <template v-slot:item.valor_recursado="{ item }">
          <span style="color:#32B88B">{{ item.valor_recursado | formatPrice }}</span>
        </template>
        <template v-slot:item.valor_acatado="{ item }">
          <span style="color:red">{{ item.valor_acatado | formatPrice }}</span>
          <!-- #31B1FF -->
        </template>
    </v-data-table>
</v-container>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      qtde: 1, 
      dinamicHeader: [...this.headers],
      showTable: true,
      porcent: 0,
      countList: 0
    }
  },
    props:{
      headers: Array,
      list: Array,
      tableName: String,
      title: String,
    },
    filters:{
        formatData(val){
        return  moment(val).format('DD/MM/YYYY')
        },
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },
    watch: {
      list(val) {
        this.countList = val.length
        this.porcent = val[0].perc_valores.toFixed(1)
      }
    },
    methods: {
      toogleShow() {
        if(this.qtde < this.list.length){
          document.querySelector(`#${this.tableName} tbody tr:first-Child`).setAttribute('class','destaque')
          this.qtde = this.list.length
        } else {
          document.querySelector(`#${this.tableName} tbody tr:first-Child`).removeAttribute('class')
          this.qtde = 1 
        }
        this.getHeader()
        // setTimeout(() => {
        //   this.showTable = true
        // }, 20);
      },
      getHeader() {
        let newHeader =[...this.headers]
        if(this.qtde == this.list.length){
          newHeader.unshift({ text: "Ident. na operadora", value: "ident_operadora", align: "left", sortable: false })
        }
        this.dinamicHeader = newHeader
      }
    },
}
</script>

<style>
tr:first-child.destaque {
  border-bottom: solid 2px #d1dcea;
  background-color: #d1dcea;
}
</style>